import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import '@/assets/style/main.scss'

let baseURL = (process.env.NODE_ENV === 'development') ? process.env.VUE_APP_LOCAL_API : process.env.VUE_APP_PROD_API
axios.defaults.baseURL = baseURL

Vue.config.productionTip = false

Vue.use({
  install (Vue) {
    Vue.prototype.$path = baseURL
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
